import { Regex } from "../../../../../../../../constant/Regex"

const { REGEX_FULL_SIZE } = Regex

export const checkIsFullSize = (value: string) => !!REGEX_FULL_SIZE.exec(value)
